<div>
  @if (purchaseId && tenantId) {
    <app-receipt
      [invoiceId]="purchaseId"
      [tenantId]="tenantId"
      [isDES]="true"
    ></app-receipt>
  } @else {
    <div class="text-error">
      <p>Unable to load receipt. URL is invalid.</p>
    </div>
  }
</div>
